import React, { useContext, useEffect } from 'react'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import { WriterFormType } from '@App/enum/writer-form-type'
import SearchResult from '@Components/WorkRegistrationSubs/SearchResult'
import { IPIValidator } from '@App/helpers/validate'
import { WriterModel } from '@Entities/work/writer-model'
import { WriterSearchResults } from '@Entities/work/writer-search-results'

interface WriterAfterFindFormProps {
    changeFormTo: (type: WriterFormType) => void
    setFoundWriterToDraft: (writer: WriterModel) => void
    addWriterToDraft: () => void
}

const WriterAfterFindForm = ({ changeFormTo, setFoundWriterToDraft, addWriterToDraft }: WriterAfterFindFormProps) => {
    const { writerSearchStore } = useContext(StoresContext)
    const searchResult = writerSearchStore.writersSearchModel

    const searchResultTitle = (writerSearchResults: WriterSearchResults) =>
        `${writerSearchResults.entity.firstName} ${writerSearchResults.entity.lastName}`

    const isValidIPI = (ipiNumber: string | null) => (ipiNumber ? IPIValidator(ipiNumber, true) : true)

    const writerRoles = (writerSearchResults: WriterSearchResults) => {
        if (writerSearchResults.entity.ipiNumber && isValidIPI(writerSearchResults.entity.ipiNumber)) {
            return [{ name: 'IPI Number', value: writerSearchResults.entity.ipiNumber }]
        }

        return []
    }

    useEffect(
        () => () => {
            writerSearchStore.clearStore()
        },
        []
    )

    return (
        <div className="writer-sub-form-component">
            <h2>
                {searchResult && searchResult.results.length > 1
                    ? 'We already have writers with those details:'
                    : 'We already have a writer with those details:'}
            </h2>
            {writerSearchStore.isThereSearchResults && (
                <div className="suggested">
                    {searchResult?.results.map((data: WriterSearchResults) => (
                        <SearchResult
                            key={data.entity.id}
                            title={searchResultTitle(data)}
                            onAddClicked={() => setFoundWriterToDraft(data.entity)}
                            onItemWasAdded={() => false}
                            roles={writerRoles(data)}
                        />
                    ))}
                </div>
            )}
            <p className="cant-find-title-after-find">Not the correct writer?</p>
            <div className="buttons-area">
                <Button mainColor type="primary" onClick={() => changeFormTo(WriterFormType.create)}>
                    Back to create
                </Button>
                <Button mainColor type="primary" onClick={addWriterToDraft}>
                    Confirm &amp; create new
                </Button>
            </div>
        </div>
    )
}

export default WriterAfterFindForm
